import React from "react";
import { StringWidget } from "./StringWidget";

export function AttributePathWidget(props) {
  const { config, doAction } = props;

  const actionButtonOptions =
  {
    icon: 'bulletlist',
    action: async (value, textElement) => {
      await doAction(config.ActionId);
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="AttributePathWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}